import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{attrs:{"id":"app"}},[_c(VMain,{staticClass:"app-content"},[_c('About'),_c('div',{attrs:{"id":"search-results-container"}},[(_vm.sharedState.searchUrl.length)?_c('PostGrid',{attrs:{"title":"Search Results","fetchUrl":_vm.sharedState.searchUrl,"showCount":""}}):_vm._e()],1),_c('router-view'),_c('Footer')],1),_c('Toolbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }